import { Component, Input } from '@angular/core';

import { GridData, CellComponent, CellContext } from '../../../models';

@Component({
  selector: 'app-checkbox-edit',
  templateUrl: './checkbox-edit.component.html',
  styleUrls: ['./checkbox-edit.component.scss'],
})
export class CheckboxEditComponent implements CellComponent<GridData> {
  @Input({ required: true }) context!: CellContext<GridData>;
}
